import { v4 as uuidv4 } from 'uuid';
import VueNativeSock from 'vue-native-websocket';
import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import LabDetails from './LabDetails';

/* Unique ID for websocket registration */
if (typeof localStorage.sender === 'undefined') {
  if (typeof (Storage) !== 'undefined') {
    localStorage.setItem('sender', `${uuidv4()}`);
  }
}

Vue.config.productionTip = false;

Vue.use(VueAxios, axios);
Vue.use(VueNativeSock, `wss://portal.beyondlabz.com/?uid=${localStorage.sender}&platform=portal`, {
  store,
  reconnection: true, // (Boolean) whether to reconnect automatically (false)
  reconnectionDelay: 3000,
});
Vue.use({
  install() {
    Vue.LabConstants = LabDetails;
    Vue.prototype.$LabDetails = LabDetails;
  },
});

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
